// eslint-disable-next-line max-classes-per-file
import './utils/previewDeepLinkBootstrap';
import './utils/authPreviewBootstrap';
import { createRoot } from 'react-dom/client';
import 'react-app-polyfill/ie11';
import 'core-js';
import React from 'react';
import PropTypes from 'prop-types';
import BrowserDetector from './utils/BrowserDetect';
import './index.styl';
import InternalLoginLayout from './components/common/LoginLayout/InternalLoginLayout';
import { currentAuthPr } from './utils/authPreview';
import WaitForAuthPr from './components/common/WaitForAuthPr';

class TopBanner extends React.Component {
    render() {
        return (
            <div className="login-responsive-wrapper">
                <div className="login">
                    <InternalLoginLayout>
                        <div className="flex-axis">
                            <br />
                            <br />
                            <br />
                            <h1>
                                <strong>Outdated browser detected!</strong> Consider upgrading or switching to a
                                different one.
                            </h1>
                        </div>
                    </InternalLoginLayout>
                </div>
            </div>
        );
    }
}

class Loading extends React.Component {
    render() {
        const { label = 'Loading' } = this.props;
        return (
            // The wrapper carries the login gradient: without it the white logo and text sit on white.
            <div className="login-responsive-wrapper">
                <div className="login">
                    <InternalLoginLayout>
                        <div className="login__loading">
                            <span>{label}</span>
                        </div>
                    </InternalLoginLayout>
                </div>
            </div>
        );
    }
}

Loading.propTypes = { label: PropTypes.string };

const loadingWith = (label) => <Loading label={label} />;

class App extends React.Component {
    constructor(props) {
        super(props);
        this.outdatedBrowser = !new BrowserDetector().isSupported();
    }

    render() {
        if (this.outdatedBrowser) {
            return <TopBanner />;
        }
        const Console = React.lazy(() => import('./Console'));

        const app = (
            <React.Suspense fallback={<Loading />}>
                <Console />
            </React.Suspense>
        );
        const authPr = currentAuthPr();
        return authPr ? (
            <WaitForAuthPr authPr={authPr} authUrl={process.env.REACT_APP_AUTH_URL} placeholder={loadingWith}>
                {app}
            </WaitForAuthPr>
        ) : (
            app
        );
    }
}

const root = createRoot(document.getElementById('root'));
root.render(<App />);
